module.exports = __webpack_public_path__ + "img/QRcode.4d61552d.jpg";